module.exports = __webpack_public_path__ + "039251e3b986c21ad72336c16b0cf940.svg";